import { NextSeo } from "next-seo"
import * as PropTypes from "prop-types"
import { getPath } from "helpers/getPath"
import { useLocale } from "react-polyglot-hooks"
import { useRouter } from "next/router"

const baseUrl = "https://swipcar.com"

export default function Canonical({ page, params, hreflang, customPath }) {
  const locale = useLocale()
  const router = useRouter()
  const alternates = []

  const resolvePath = (loc) => {
    if (customPath) {
      if (loc === 'es' && customPath === '/') {
        return ''
      }
      return customPath.startsWith(`/${loc}`) ? customPath : `/${loc}${customPath}`
    }
    
    const p = getPath(loc, page, params)
    if (p) return `/${loc}${p}`
    
    let currentPath = router.asPath
    
    currentPath = currentPath.replace('/seo_pages/', '/')
    
    const knownLocales = ['es', 'pt', 'it']
    let pathWithoutLocale = currentPath
    
    const foundLocale = knownLocales.find(knownLocale => 
      currentPath.startsWith(`/${knownLocale}/`) || currentPath === `/${knownLocale}`
    )
    
    if (foundLocale) {
      pathWithoutLocale = currentPath.substring(foundLocale.length + 1) || '/'
    }
    
    if (pathWithoutLocale === '/') {
      return `/${loc}`
    }
    
    if (loc === 'es' && pathWithoutLocale === '/') {
      return ''
    }
    
    return `/${loc}${pathWithoutLocale === '/' ? '' : pathWithoutLocale}`
  }

  if (hreflang) {
    const defaultHref = resolvePath("es")
    alternates.push({
      hrefLang: "x-default",
      href: `${baseUrl}${defaultHref}`,
    })
  }

  const canonicalHref = `${baseUrl}${resolvePath(locale)}`

  return (
    <NextSeo
      languageAlternates={alternates}
      canonical={canonicalHref}
    />
  )
}

Canonical.defaultProps = {
  params: {},
  hreflang: true,
  customPath: null
}

Canonical.propTypes = {
  page: PropTypes.string.isRequired,
  params: PropTypes.object,
  hreflang: PropTypes.bool,
  customPath: PropTypes.string
}
